import AUTH_BASE_URL from '../../util/AUTH_BASE_URL'

export function connectToGitLab (email) {
   window.location.href = `${AUTH_BASE_URL}auth/gitlab`
}
